module.exports = __webpack_public_path__ + "img/95a87b34-0cbf-11ec-b3b5-0800270bb7ac.b553ca5c.svg";